import React, { useEffect } from "react";

import {

    Dialog,

    DialogTitle,

    DialogContent,

    DialogActions,

    IconButton,

    Typography,

} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";
 
const SuccessDialog = ({

    open,

    onClose,

    title = "Settings Saved Successfully!",

}) => {

    useEffect(() => {

        if (open) {

            const timer = setTimeout(() => {

                onClose();

            }, 4000);
 
            return () => clearTimeout(timer);

        }

    }, [open, onClose]);
 
    return (
<Dialog

            open={open}

            onClose={onClose}

            sx={{

                "& .MuiPaper-root": {

                    width: "360px",

                    maxWidth: "360px",

                    borderRadius: "10px",

                    overflow: "hidden",

                },

            }}
>

            {/* Header */}
<DialogTitle

                sx={{

                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    borderBottom: "1px solid #E7E8E9",

                    padding: "8px 12px",

                    minHeight: "48px",

                }}
>
<Typography

                    sx={{

                        fontSize: "18px",

                        fontWeight: 600,

                    }}
>

                    Success
</Typography>
 
                <IconButton

                    size="small"

                    onClick={onClose}

                    sx={{ padding: "4px" }}
>
<CloseIcon fontSize="small" />
</IconButton>
</DialogTitle>
 
            {/* Content */}
<DialogContent

                sx={{

                    padding: "16px !important",

                }}
>
<div

                    style={{

                        textAlign: "center",

                    }}
>
<img

                        src="/images/succesfull-check.png"

                        alt="Success"

                        style={{

                            width: 40,

                            height: 40,

                            marginBottom: 8,

                        }}

                    />
 
                    <Typography

                        sx={{

                            fontSize: "13px",

                            color: "#4b5563",

                            lineHeight: 1.4,

                        }}
>

                        {title}
</Typography>
</div>
</DialogContent>
 
            {/* Footer */}
<DialogActions

                sx={{

                    padding: "8px",

                    borderTop: "1px solid #E7E8E9",

                    justifyContent: "center",

                }}
>
<button

                    className="btn"

                    style={{

                        minWidth: "50px",

                        height: "32px",

                        padding: "4px 12px",

                    }}

                    onClick={onClose}
>

                    OK
</button>
</DialogActions>
</Dialog>

    );

};
 
export default SuccessDialog;
 